var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#DB3E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 -0.00585938H513V341.994H331V-0.00585938Z",
    fill: "#479900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H181.8V341.994H0V-0.00585938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 126.694C236.6 126.694 220.8 142.494 220.8 161.894V214.694H291.2V161.894C291.2 142.394 275.4 126.694 256 126.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 84.2942C208.3 84.2942 169.6 122.994 169.6 170.694C169.6 218.394 208.3 256.994 256 256.994C303.7 256.994 342.4 218.294 342.4 170.594C342.4 122.894 303.7 84.2942 256 84.2942ZM256 241.994C216.6 241.994 184.6 209.994 184.6 170.594C184.6 131.194 216.6 99.1942 256 99.1942C295.4 99.1942 327.4 131.194 327.4 170.594C327.4 210.094 295.4 241.994 256 241.994Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/AF.be164fe563add1c2e658c98def5ff533.svg";
export { ForwardRef as ReactComponent };